import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';

import { DeviceFormComponent } from '../../../../devices/device-form/device-form.component';
@Component({
  selector: 'app-customer-plan-device-update',

  templateUrl: './customer-plan-device-update.component.html',
  styleUrl: './customer-plan-device-update.component.css',
    imports: [DeviceFormComponent]
})
export class CustomerPlanDeviceUpdateComponent {

  information: string = 'Update SIM / ICCID: ';
  devceID: string = '';
  isEditing: boolean = false;
  isAdmin: boolean = false;
  isCustomer: boolean = false;
  isPartner: boolean = false;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public permissionsService: ValidatePermissionsService,

  ) { }

  ngOnInit() {

    this.isAdmin = this.permissionsService.isAdmin;
    this.isCustomer = this.permissionsService.isCustomer;
    this.isPartner = this.permissionsService.isPartner;

    debugger

    this.route.params.subscribe(params => {

      this.devceID = (params['iccid']); // Access the 'id' parameter from the URL
      if (this.devceID) {
        this.isEditing = true
      }
    });

    if (this.isEditing) {
      //this.simData = history.state.simData;
      this.information = this.information + this.devceID;
    }
  }

  handleCreateUpdateResponse(event: string) {

    if (!event) {
      window.history.back();
    }

  }



  goBack() {
    window.history.back();
  }
}
